import log from 'loglevel';
import type { Logger } from 'loglevel';
import Config from "./Config";
import type { AppConfig } from "./Config";

/**
 * Base class for services. Provides:
 * - Logging
 * - Configuration 
 */
class BaseService  {
    
    /**
     * Log messages to console.
     *
     * Subclasses override it to name their own logger, so every static method
     * here resolves it through `this` rather than calling log directly.
     */
    static logger(): Logger {
        return log.getLogger('BaseService');
    }

    /**
     * Debug facility, quick log to console.
     */
    static debug(message: string, data: unknown = null): void {
      this.logger().debug(message, data);
    }
    
    /**
     * Info, for regular logs.
     */
    static info(message: string, data: unknown = null): void {
      this.logger().info(message, data);
    }

    /**
     * Configuration data.
     */
    static config(): AppConfig {
        return Config.config();
    }
    
    /**
     * Checks for network connection.
     */
    static isOnline(): boolean {
      return window.navigator.onLine;
    }
}

export default BaseService;
